// @flow
import React, { useContext } from 'react';
import {
  FieldArrayGridConfigItemContext,
  FieldArrayGridTextField,
} from '@src/formik-utils/FieldArrayGrid';
import { getDiscountColumnConfig, getIfRowIsVBD } from '@components/custom-discounts/utils';

export const CommitDimensionsConfigDiscountContainer = () => {
  const { columnsConfiguration, rowValues } = useContext(FieldArrayGridConfigItemContext);
  const discountColumnConfig = getDiscountColumnConfig(columnsConfiguration);
  return (
    <FieldArrayGridTextField
      columnConfig={discountColumnConfig}
      disableOnFormErrors={null}
      disableTextField={getIfRowIsVBD(rowValues)}
    />
  );
};
